import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import agent from '../api/agent';
import { CCTTiposTransXTipoCta, CCTTiposTransXTipoCtaFormValues } from '../models/CCTTiposTransXTipoCta';

export default class CCTTiposTransXTipoCtaStore {

    CCTTiposTransXTipoCtaRegistry = new Map<any, CCTTiposTransXTipoCta>();

    selectedCCTTiposTransXTipoCta: CCTTiposTransXTipoCta | undefined = undefined;
    editMode = false;
    loading = false;
    loadingInitial = false;
 

    constructor() {
        makeAutoObservable(this)
    }

    get CCTTiposTransXTipoCtaByCodigo() {
        return Array.from(this.CCTTiposTransXTipoCtaRegistry.values());
    }

    loadCCTTiposTransXTipoCtas = async () => {
        this.loadingInitial = true;
        try {
            const CCTTiposTransXTipoCtas: CCTTiposTransXTipoCta[]= await agent.CCTTiposTransXTipoCtas.list();
            CCTTiposTransXTipoCtas.forEach(CCTTiposTransXTipoCta => {
                this.setCCTTiposTransXTipoCta(CCTTiposTransXTipoCta);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadCCTTiposTransXTipoCta = async (codigoTipoCuenta: string) => {
        let CCTTiposTransXTipoCta = this.getCCTTiposTransXTipoCta(codigoTipoCuenta);
        if (CCTTiposTransXTipoCta) {
            this.selectedCCTTiposTransXTipoCta = CCTTiposTransXTipoCta;
            return CCTTiposTransXTipoCta;
        } else {
            this.loadingInitial = true;
            try {
                CCTTiposTransXTipoCta =  await agent.CCTTiposTransXTipoCtas.details(codigoTipoCuenta);
                this.setCCTTiposTransXTipoCta(CCTTiposTransXTipoCta);
                runInAction(() => {
                    this.selectedCCTTiposTransXTipoCta = CCTTiposTransXTipoCta || this.selectedCCTTiposTransXTipoCta;
                })
                this.setLoadingInitial(false);
                return CCTTiposTransXTipoCta;
            } catch (error) {
                // toast.error(error);
                this.setLoadingInitial(false);
                return CCTTiposTransXTipoCta;
            }
        }
    }

    private setCCTTiposTransXTipoCta = (CCTTiposTransXTipoCta: CCTTiposTransXTipoCta) => {
        this.CCTTiposTransXTipoCtaRegistry.set(CCTTiposTransXTipoCta.codigoTipoCuenta, CCTTiposTransXTipoCta);
    }

    private getCCTTiposTransXTipoCta = (codigoTipoCuenta: any) => {
        return this.CCTTiposTransXTipoCtaRegistry.get(codigoTipoCuenta);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createCCTTiposTransXTipoCta = async (CCTTiposTransXTipoCta: CCTTiposTransXTipoCtaFormValues) => {
        try {
            await agent.CCTTiposTransXTipoCtas.create(CCTTiposTransXTipoCta);
            runInAction(() => {
                this.selectedCCTTiposTransXTipoCta = CCTTiposTransXTipoCta;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    updateCCTTiposTransXTipoCta = async (CCTTiposTransXTipoCta: CCTTiposTransXTipoCtaFormValues) => {
        try {
            await agent.CCTTiposTransXTipoCtas.update(CCTTiposTransXTipoCta);
            runInAction(() => {
                if (CCTTiposTransXTipoCta.codigoTipoCuenta) {
                    let updateCCTTiposTransXTipoCta = {...this.getCCTTiposTransXTipoCta(CCTTiposTransXTipoCta.codigoTipoCuenta), ...CCTTiposTransXTipoCta}
                    this.CCTTiposTransXTipoCtaRegistry.set(CCTTiposTransXTipoCta.codigoTipoCuenta, updateCCTTiposTransXTipoCta as CCTTiposTransXTipoCta);
                    this.selectedCCTTiposTransXTipoCta = updateCCTTiposTransXTipoCta as CCTTiposTransXTipoCta
                    this.loading = false;
                }
                   
            } )
        } catch (error) {
        }
    }

    deleteCCTTiposTransXTipoCta = async (codigoTipoCuenta: string) => {
        this.loading = true;
        try {
            await agent.CCTTiposTransXTipoCtas.delete(codigoTipoCuenta);
            runInAction(() => {
                this.CCTTiposTransXTipoCtaRegistry.delete(codigoTipoCuenta);
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }


}